import { UploadExcelThemeSizeConfig } from './types';

const small: UploadExcelThemeSizeConfig = {
  uploadExcel: {},
};

export default small;
